import * as id from 'src/app/shared/constants/pageUid';
import * as route from 'src/app/shared/constants/routes';

export const routeToPageIdMapping: Record<string, string> = {
  [route.ROUTE_CREATE]: id.PAGE_ID_CREATE,
  [route.ROUTE_CLASSIFY]: id.PAGE_ID_CLASSIFY,
  [route.ROUTE_CONCIERGE]: id.PAGE_ID_CONCIERGE,
  [route.ROUTE_GUARANTEED_HIRE]: id.PAGE_ID_GUARANTEED_HIRE,
  [route.ROUTE_PREMIUM_PLUS]: id.PAGE_ID_PREMIUM_PLUS,
  [route.ROUTE_MANAGE]: id.PAGE_ID_MANAGE,
  [route.ROUTE_PAY_AND_POST]: id.PAGE_ID_PAY_AND_POST,
  [route.ROUTE_PAY_AND_POST_V2]: id.PAGE_ID_PAY_AND_POST_V2,
  [route.ROUTE_SELECT_AD_TYPE]: id.PAGE_ID_SELECT_AD_TYPE,
  [route.ROUTE_SUCCESS]: id.PAGE_ID_SUCCESS,
  [route.ROUTE_TEST_PAGE]: id.PAGE_ID_TEST_PAGE,
  [route.ROUTE_WRITE]: id.PAGE_ID_WRITE,
  [route.ROUTE_EDIT]: id.PAGE_ID_EDIT,
  [route.ROUTE_EDIT_PAY_AND_POST]: id.PAGE_ID_EDIT_PAY_AND_POST,
  [route.ROUTE_EDIT_SUCCESS]: id.PAGE_ID_EDIT_SUCCESS,
  [route.ROUTE_REFRESH]: id.PAGE_ID_REFRESH,
  [route.ROUTE_REFRESH_SUCCESS]: id.PAGE_ID_REFRESH_SUCCESS,
  [route.ROUTE_REFRESH_ERROR]: id.PAGE_ID_REFRESH_ERROR,
  [route.ROUTE_MULTI_LOCATION]: id.PAGE_ID_MULTI_LOCATION,
};
